module.exports = __webpack_public_path__ + "img/red-cw-logo-no-text-inverted.2b89c973.svg";